import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('negociacao', 'configuracao');

const configuracaoNegociacaoActions = {
  orcamentoHabilitado: { method: 'GET', url: `${basePath}/orcamento-habilitado` },
  roiHabilitado: { method: 'GET', url: `${basePath}/roi-habilitado/{tipoAcordo}` },
  workflowHabilitado: { method: 'GET', url: `${basePath}/workflow-habilitado` },
  valorParametro: { method: 'GET', url: `${basePath}/{tipoAcordo}/{grupo}/{chave}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoNegociacaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/negociacao/configuracao-negociacao.js